// Shared formatting utilities for currency and units.

export const UNITS = [
  { value: 'pauschal', label: 'Pauschal' },
  { value: 'monatlich', label: 'Monatlich' },
  { value: 'stündlich', label: 'Stündlich' },
  { value: 'stück', label: 'Stück' },
  { value: 'kg', label: 'Kilogramm' },
  { value: 'm', label: 'Meter' },
  { value: 'm²', label: 'Quadratmeter' },
  { value: 'liter', label: 'Liter' },
  { value: 'tag', label: 'Tag' },
];

export const unitLabel = (unit) => UNITS.find((u) => u.value === unit)?.label || unit;

export const formatEuro = (value) =>
  new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(Number(value) || 0);
